/**
 * Retry Boost Video Payment UseCase
 *
 * Retries the failed boost-video payment for a content item.
 * Mirrors Flutter MediasRepository.retryBoostVideoPayment →
 * CloudFunctionsService.retryBoostVideoPayment
 * (lib/data/repository/medias_repository.dart:393-395).
 *
 * The returned boolean is load-bearing: the caller branches a "Done" vs
 * "There was an error. Please try again!" toast on it
 * (lib/services/push_navigation_service.dart:532-547).
 */

import { MediaService } from '@/domain/services/media/mediaService';
import { appLogger } from '@/domain/services/analytics/appLogger';

export class RetryBoostVideoPaymentUseCase {
  private mediaService: MediaService;

  constructor(mediaService?: MediaService) {
    this.mediaService = mediaService || new MediaService();
  }

  async execute(contentId: string): Promise<boolean> {
    try {
      return await this.mediaService.retryBoostVideoPayment(contentId);
    } catch (error) {
      appLogger.error('Error retrying boost video payment', 'RetryBoostVideoPaymentUseCase.execute', { error: error as Error });
      return false;
    }
  }
}

export const retryBoostVideoPaymentUseCase = new RetryBoostVideoPaymentUseCase();
